export enum OPERATION_TIME_CATEGORY {
  BREAKFAST = '아침',
  LUNCH = '점심',
  LATE_NIGHT = '야간',
  DINNER = '저녁',
}
export const CONST_OPERATION_TIME_CATEGORY = Object.values(
  OPERATION_TIME_CATEGORY,
);
